import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useDashboardContext, ViewMode } from "./dashboardContext";
import ChairIcon from "@mui/icons-material/Chair";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { FunctionComponent } from "react";

export const DashboardPageHeader: FunctionComponent = () => {
    const {
        currentView,
        setCurrentView,
    } = useDashboardContext();

    return (
        <Box display="flex" flexDirection="column" alignItems="flex-start" gap={"0.5rem"} justifyContent="flex-start" padding={2}>
            <Typography variant="h4">
                Tableau de bord - {currentView === ViewMode.PRODUCT ? "Vue par produit" : "Vue par magasin"}
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="flex-start" width="100%">
                <ToggleButtonGroup
                    exclusive
                    value={currentView}
                    onChange={(_, newView) => {
                        if (!newView) return;
                        setCurrentView(newView)
                    }}
                    size={"small"}
                >
                    <ToggleButton value={ViewMode.PRODUCT}>
                        <ChairIcon />
                        <span style={{ marginLeft: 8 }}>Produits</span>
                    </ToggleButton>
                    <ToggleButton value={ViewMode.STORE}>
                        <StorefrontIcon />
                        <span style={{ marginLeft: 8 }}>Magasins</span>
                    </ToggleButton>
                </ToggleButtonGroup>
            </Box>
        </Box>
    )
};

export default DashboardPageHeader;